import {ComponentFactoryResolver,ComponentRef,Directive,Input,OnInit,ViewContainerRef} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { PageConfig } from "../models/page.interface";
import { PageComponent } from "../page/page.component";
const componentMapper = {
  page: PageComponent
};
@Directive({
  selector: '[appPage]'
})
export class PageDirective {

  @Input() page: PageConfig;
  @Input() group: FormGroup;
  componentRef: any;
  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) {}
  ngOnInit() {
    const factory = this.resolver.resolveComponentFactory(
      componentMapper[this.page.type]
    );
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.page = this.page;
    this.componentRef.instance.group = this.group;
  }

}



// WEBPACK FOOTER //
// ./src/app/rFF/directives/page.directive.ts